module.exports = __webpack_public_path__ + "static/media/page-6.9b8dc73d.png";